/**
 * Common
 */

export default function Common() {
    const mapRetainedClients = jQuery('.map_retained_clients');
    const caseStudiesSlider = jQuery('.case-studies-slider');
    const $celebratedCollaborationsSlider = jQuery('.celebrated-collaborations-slider');
    const bannerSection = jQuery(".banner-section");
    let lastScrollTop = (bannerSection.length > 0) ? bannerSection.offset().top : 0;
    const scrollTrigger = jQuery("*[scroll-trigger]");

    this.init = () => {
        this.addDraw();
        this.caseStudiesSlider();
        this.celebratedCollaborationsSlider();
        this.toggleStickyTableOfContent();
        this.tableOfContentTrigger();
        this.logoFeaturesSlider();
    };

    this.addDraw = () => {
        jQuery(document).on('scroll', function () {
            const scroll = jQuery(window).scrollTop();

            if(mapRetainedClients.length > 0) {
                const mapRetainedClientsOffset = mapRetainedClients.offset().top - 500;

                if (scroll > mapRetainedClientsOffset) {
                    jQuery(".box").addClass("draw");

                    setTimeout(function () {
                        jQuery(".cCanada").css("display", "block");
                    }, 1700);

                    setTimeout(function () {
                        jQuery(".cFrance").css("display", "block");
                    }, 990);

                    setTimeout(function () {
                        jQuery(".cNorway").css("display", "block");
                    }, 1100);

                    setTimeout(function () {
                        jQuery(".cHK").css("display", "block");
                    }, 200);

                    setTimeout(function () {
                        jQuery(".cAu").css("display", "block");
                    }, 500);
                }
                document.getElementById('start').beginElement();
            }
        });
    }

    this.caseStudiesSlider = () => {
        caseStudiesSlider.slick({
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<div class="slick-arrow slick-prev arrow-slide-white"></div>',
            nextArrow: '<div class="slick-arrow slick-next arrow-slide-white"></div>',
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    this.toggleStickyTableOfContent = () => {
        jQuery(window).on('scroll', function(event){
            const st = jQuery(this).scrollTop();

            if (st > lastScrollTop){
                jQuery(".table-of-section").addClass('sticky');
            } else {
                jQuery(".table-of-section").removeClass('sticky');
            }
            lastScrollTop = st;
        });
    }

    this.tableOfContentTrigger = () => {
        scrollTrigger.on('click', function(e) {
            e.preventDefault();
            const triggerAttr = jQuery(this).attr('scroll-trigger');
            const scrollTarget = jQuery('*[scroll-target=' + triggerAttr + ']');

            scrollTrigger.removeClass('active');
            jQuery(this).addClass('active');

            jQuery('html, body').stop().animate({
                scrollTop: scrollTarget.offset().top - 0
            }, 600 );

            return false;
        });

        jQuery(window).on('scroll', function() {
            const scrollPosition = jQuery(window).scrollTop();

            scrollTrigger.each(function() {
                const triggerAttr = jQuery(this).attr('scroll-trigger');
                const scrollTarget = jQuery('*[scroll-target=' + triggerAttr + ']');

                if (scrollTarget.offset().top <= scrollPosition + jQuery(window).height() / 2 &&
                    scrollTarget.offset().top + scrollTarget.outerHeight() > scrollPosition + jQuery(window).height() / 2) {

                    scrollTrigger.removeClass('active');
                    jQuery(this).addClass('active');
                }
            });
        });
    }

    this.logoFeaturesSlider = () => {
        jQuery('.logo-features-lists').slick({
            accessibility: true,
            focusOnSelect: false,
            speed: 2500,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        speed: 1500,
                    }
                }
            ]
        });
    }

    this.celebratedCollaborationsSlider = () => {
        $celebratedCollaborationsSlider.slick({
            speed: 3000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false
        });
    }
}
